export default function CloseIcon() {
    return (
        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 1.00195L1 16.002M1 1.00195L17 16.002" stroke="#B3BBC4" strokeWidth="1.5"
                  strokeLinecap="round" strokeLinejoin="round"></path>
        </svg>
    )
}
